import type { CSSProperties, ReactNode } from 'react';
import { Icon } from '../core/Icon';

export interface EmptyStateProps {
    /** Nome do ícone no Lucide. */
    icon?: string;
    title?: ReactNode;
    description?: ReactNode;
    action?: ReactNode;
    secondaryAction?: ReactNode;
    /** Reduz o respiro vertical, para uso dentro de card ou tabela. */
    compact?: boolean;
    style?: CSSProperties;
}

export function EmptyState({
    icon = 'inbox', title, description, action, secondaryAction, compact = false, style,
}: EmptyStateProps) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 6, padding: compact ? '28px 20px' : '52px 24px', ...style }}>
            <span style={{ width: 40, height: 40, borderRadius: 'var(--radius-lg)', background: 'var(--surface-secondary)', border: '1px solid var(--border-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--neutral-500)', marginBottom: 6 }}>
                <Icon name={icon} size={19} />
            </span>
            <p style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 16, lineHeight: '24px', fontWeight: 600, color: 'var(--text-primary)' }}>{title}</p>
            {description && (
                <p style={{ margin: 0, maxWidth: 380, fontSize: 13.5, lineHeight: '20px', color: 'var(--text-secondary)', textWrap: 'pretty' }}>{description}</p>
            )}
            {(action || secondaryAction) && <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 8, marginTop: 10 }}>{action}{secondaryAction}</div>}
        </div>
    );
}
